import { render, staticRenderFns } from "./AddPotentialProduct.vue?vue&type=template&id=c4a1e048&"
import script from "./AddPotentialProduct.vue?vue&type=script&lang=js&"
export * from "./AddPotentialProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports